import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { TableIncomingData } from "../../../../models/Tables";

export interface IDelegationManagementStepOneProps {
  delegations: any[];
  delegationsLoader: any;
  callState: IResponseState;
  delegationRequest: () => {};
  resetCallState: () => {};
  modifyDelegations: (delegations: any[]) => {};
  modifyDelegationRequest: (id: string, modifyDate: {}) => {};
  deleteDelegationRequest: (id: string) => {};
  resetDelegationState: () => {};
  changeLocation: (url: string) => {};
}

export const DELEGATION_MANAGEMENT_STEP_1_FORM_FILTER =
  "DelegationManagementStep1FormFilter";

export const TypeFilter = {
  delegatedFilter: "delegated",
  roleFilter: "role",
  startDateFilter: "begin_date",
  endDateFilter: "end_date",
};

export const mockDelegations: TableIncomingData[] = [
  {
    id: 1,
    role: "Ruolo 1",
    delegate: "Delegato 1 ",
    start_validity: "1/1/2021",
    end_validity: "31/12/2021",
  },
  {
    id: 2,
    role: "Ruolo 2",
    delegate: "Delegato 2",
    start_validity: "1/1/2022",
    end_validity: "31/12/2022",
  },
  {
    id: 3,
    role: "Ruolo 3",
    delegate: "Delegato 3",
    start_validity: "1/1/2023",
    end_validity: "31/12/2023",
  },
];
